/**
 * Script will be enqueued both in the editor and when viewing the content on the front of the site.
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#script
 */
// include styles for the front end only
import './index.scss';
